import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import { registerServiceWorker } from '@/pwa/register';
import '@lichess-org/chessground/assets/chessground.base.css';
import '@/styles/tokens.css';
import '@/styles/global.css';

const rootElement = document.getElementById('root');

if (rootElement === null) {
  throw new Error('CapyChess could not find its application root.');
}

const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);

import.meta.hot?.dispose(() => root.unmount());

registerServiceWorker();
